import React from 'react';

import { VStack } from 'ui/Layout';
import { Text } from 'ui/Typography';

import { useSankeyExcelBindingContext } from '../../contexts/sankeyExcelBindingContext';
import DataSourceBindingAddress from '../DataSourceBindingAddress';
import ToolCard from '../ToolCard';
import DataGrid from './DataGrid';
import DataSourceNotes from './DataSourceNotes';
import { useIsDataFromExcel } from './utils';

const DataEditor: React.FC = () => {
  const isDataFromExcel = useIsDataFromExcel();
  const { hasExcelBindingInThisSheet } = useSankeyExcelBindingContext();

  return (
    <ToolCard title="Data editor" color="gray">
      <VStack alignItems="stretch" pt={4} gap={4} pb={2} w="100%">
        {hasExcelBindingInThisSheet ? (
          <Text color="gray.700" fontSize="sm">
            The data for this diagram is sourced from this spreadsheet. Please
            edit the cell values cells to update the diagram or change the data
            source: <DataSourceBindingAddress />
          </Text>
        ) : isDataFromExcel ? (
          <Text color="gray.700" fontSize="sm">
            The data for this diagram is sourced from an Excel spreadsheet.
            Please update the cell values in your spreadsheet to update the
            diagram shape.
          </Text>
        ) : (
          <DataGrid />
        )}
        <DataSourceNotes />
      </VStack>
    </ToolCard>
  );
};

export default React.memo(DataEditor);
